var map = {
	"./Activity-Icon.png": 3607,
	"./Lifestyle-Icon.png": 179,
	"./Lifestyle-alt-Icon.png": 3864,
	"./MentalWellbeing-Icon.png": 3871,
	"./Nutrition-Icon.png": 3,
	"./Sleep-Icon.png": 9323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3629;